import React, { useEffect, useState } from 'react'
import DataTable, { Alignment } from 'react-data-table-component';
import { NavLink, useParams } from 'react-router-dom'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col, Input, Table } from 'reactstrap'

import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { dataToXLS } from '../../../helpers/dataToXLS';
import { requestApi } from '../../../request-api';
import { useLocation, useNavigate } from 'react-router-dom';
function BranchDetail() {
  let [isChecked, setIsChecked] = useState(false);
  let [branch, setBranch] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [company, setCompany] = useState([])
  const [companyCount, setCompanyCount] = useState(0)
  const [search, setSearch] = useState("")
  const [filteredSearch, setFilteredSearch] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [date, setDate] = useState([]);
  
  let [downloadData, setDownloadData] = useState([]);
  const [companyId, setCompanyId] = useState([]);
  const [listCount, setListCount] = useState(0)
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  let navigate = useNavigate()
  let location = useLocation();
  let { id } = useParams()

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

   const downloadReport = (reportId) => {
     dataToXLS(downloadData, 'Branch');
   };
  let count = 0
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: 5000000
  })


  const [columns, setColumns] = useState([
    {
      name: 'Sr.No.',
      selector: (row,index) => {
        count += 1;
        return (
          <td>
            {index+1} &nbsp;{' '}
          </td>
        )
      },
      sortable: true,
    },
    {
      name: 'Company Name',
      selector: (row) => row.company_name,
      sortable: true,
    },
    {
      name: 'Branch ID',
      selector: (row) => row.branch_id,
      sortable: true,
    },
    {
      name: 'Branch POC Number',
      selector: (row) => row.branch_poc_name,
      sortable: true,
    },
    {
      name: 'Date of Joining',
      selector: (row) => row.date_of_joining,
      sortable: true,
    },
    {
      name: 'POC Number',
      selector: (row) => row.poc_number,
      sortable: true,
    },
    {
      name: 'Assigned Compliancer Officer',
      selector: (row) => row.compliance_officer_id,
      sortable: true,
    },
    {
      name: 'Office Address',
      selector: (row) => row.office_address,
      sortable: true,
    }, ,
    {
      name: 'Action',
      grow: 2,
      selector: (row) => (
        <td>
          <NavLink
            className="text-decoration-none"
            to={`${directUrl}auditor/branch-edit/${row.branch_id}`}
          >
            <i className="icon icon-edit-new"></i>
          </NavLink>
        </td>
      ),
    },
  ]);

  const dummy = (e) => {
    if (e.allSelected == true) {
      setDownloadData(e.selectedRows);
    } else if (e.allSelected == false && e.selectedCount == 0) {
      setDownloadData([]);
    } else if (e.selectedCount > 0) {
      setDownloadData(e.selectedRows);
    } else if (e.selectedCount == 0) {
      setDownloadData([]);
    }
    if (e.selectedCount == 0) {
      setIsChecked(false);
    }
    else {
      setIsChecked(true);
    }
  }

  useEffect(() => {

    onGetBranch(); 




  }, [pagination])


  const onGetBranch = () => {

    requestApi(`/auditor/branch/getBranchOfCompany/${id}`, {
      method: 'post',
      body: JSON.stringify({
        skip: pagination.skip,
        limit: pagination.limit
      })

    }).then((data) => {
      if (data.statusCode === 200) {
        console.log(data.data)
        setBranch(data.data);
        setCompanyCount(data.data.length);
        setListCount(data.data.length)


      }

    })

  }


  return (
    <section className="lyt-section">
      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb mt-0">
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/clients`}>Clients</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem active>{location.state.row.company_name}</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card">
          <Row>
            {isChecked ? (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="bs-action-btn">
                  <div className="button-group">
                    <a
                      className="action-btn"
                      onClick={(e) => {
                        downloadReport();
                      }}
                    >
                      {' '}
                      <span class="icon icon-download"></span>
                    </a>
                    {/* <a className="action-btn" href="">
                      {' '}
                      <span class="icon icon-share"></span>
                    </a>
                    <a className="action-btn" href="">
                      <span class="icon icon-delete"></span>
                    </a> */}
                  </div>
                </div>
              </Col>
            ) : null}
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="bs-table typ-datable overflow-on">
                <DataTable
                  columns={columns}
                  data={branch}
                  header
                  subHeader={false}
                  subHeaderAlign={Alignment.LEFT}
                  fixedHeader
                  fixedHeaderScrollHeight="450px"
                  pagination
                  selectableRows
                  onSelectedRowsChange={dummy}
                  selectableRowsHighlight
                  highlightOnHover
                />

                {/* <Table responsive>
                        <thead>
                            <tr>
                                <th><Input type="checkbox" />{' '}</th>
                                <th>Sr.No.</th>
                                <th>Branch <span className='d-block'>Name</span></th>
                                <th>Branch_ID </th>
                                <th>Branch POC <span className='d-block'>Number</span></th>
                                <th>Date of <span className='d-block'>Joining</span></th>
                                <th>POC <span className='d-block'>Number</span></th>
                                <th>Assigned Complaincer <span className='d-block'>Officer</span></th>
                                <th>Office Address</th>
                                <th>Action</ th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                <td>1</td>
                                <td>Worli</td>
                                <td>HDFC_Worli</td>
                                <td>Worli_Ramesh</td>
                                <td>01/09/22</td>
                                <td>Ramesh_91123456789</td>
                                <td>Saloni Parihar</td>
                                <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                <td><NavLink className="text-decoration-none"><i className='icon icon-edit-new'></i></NavLink></td>                      
                            </tr>
                            <tr>
                                <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                <td>2</td>
                                <td>Dadar</td>
                                <td>HDFC_Dadar</td>
                                <td>Dadar_Ramesh</td>
                                <td>01/09/22</td>
                                <td>Ramesh_91123456789</td>
                                <td>Saloni Parihar</td>
                                <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                <td><NavLink className="text-decoration-none"><i className='icon icon-edit-new'></i></NavLink></td>       
                            </tr>
                            <tr>
                                <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                <td>3</td>
                                <td>CST</td>
                                <td>HDFC_CST</td>
                                <td>CST_Ramesh</td>
                                <td>01/09/22</td>
                                <td>Ramesh_91123456789</td>
                                <td>Saloni Parihar</td>
                                <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                <td><NavLink className="text-decoration-none"><i className='icon icon-edit-new'></i></NavLink></td>       
                            </tr>
                            <tr>
                                <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                <td>4</td>
                                <td>Thane</td>
                                <td>HDFC_Thane</td>
                                <td>Thane_Ramesh</td>
                                <td>01/09/22</td>
                                <td>Ramesh_91123456789</td>
                                <td>Saloni Parihar</td>
                                <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                <td><NavLink className="text-decoration-none"><i className='icon icon-edit-new'></i></NavLink></td>       
                            </tr>
                            <tr>
                                <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                <td>5</td>
                                <td>Kurla</td>
                                <td>HDFC_Kurla</td>
                                <td>Kurla_Ramesh</td>
                                <td>01/09/22</td>
                                <td>Ramesh_91123456789</td>
                                <td>Saloni Parihar</td>
                                <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                <td><NavLink className="text-decoration-none"><i className='icon icon-edit-new'></i></NavLink></td>    
                            </tr>
                        </tbody>
  </Table>*/}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default BranchDetail
